<template>
  <div class="orderContainer" v-sound>
    <h2 class="orderTitle">お会計一覧</h2>
    <hr class="titleLine" />
    <div class="orderList">
      <table class="orderTable">
        <thead>
          <tr>
            <th>
              <div class="statusFilter">
                <span>注文卓</span>
                <select v-model="selectedTable" @change="filterSessions">
                  <option value="all">全て</option>
                  <option v-for="table in tables" :key="table.id" :value="table.id">
                    {{ table.label }}
                  </option>
                </select>
              </div>
            </th>
            <th>
              <div class="statusFilter">
                <span>会計状況</span>
                <select v-model="activeTab" @change="filterSessions">
                  <option value="all">全て</option>
                  <option value="waiting">お会計待ち</option>
                  <option value="completed">お会計済み</option>
                </select>
              </div>
            </th>
            <th>お会計</th>
            <th>注文内訳</th>
            <th>
              <span>お会計日時</span>
              <div class="dateFilter">
                <select v-model="selectedYear" @change="filterSessions">
                  <option value="all">全て</option>
                  <option v-for="year in years" :key="year" :value="year">{{ year }}</option>
                </select>
                <select v-model="selectedMonth" @change="filterSessions">
                  <option value="all">全て</option>
                  <option v-for="month in months" :key="month" :value="month">{{ month }}</option>
                </select>
                <select v-model="selectedDate" @change="filterSessions">
                  <option value="all">全て</option>
                  <option v-for="date in dates" :key="date" :value="date">{{ date }}</option>
                </select>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(session, index) in filteredSessions" :key="index">
            <td>{{ session.diningTables.label }}</td>
            <td>
              <span v-if="session.status === 1">お会計待ち</span>
              <span v-else>お会計済み</span>
            </td>
            <td class="totalAmount">
              {{ Math.round( ( session.total_amount || 0) / 1.1).toLocaleString() }}円
              <br>
                (税込{{ (session.total_amount || 0).toLocaleString() }}円)
            </td>
            <td>
              <button class="detailButton" @click="showOrderDetail(session)">開く</button>
            </td>
            <td>{{ formatDate(session.ended_at) }}</td>
          </tr>
          <!-- 空行を追加して6行分を埋める -->
          <tr v-for="index in Math.max(10 - filteredSessions.length, 0)" :key="'empty-' + index">
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="buttonContainer">
        <button class="backButton" @click="this.$router.push('/order-list');">注文確認画面</button>
        <button class="backButton" @click="this.$router.push('/admin');">管理ページTOP</button>
      <div><button class="reloadButton" @click="fetchData">更新</button></div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  data() {
    return {
      orderitems: [],
      tablesessions: [],
      totalAmount: 0, // 合計金額
      tables: [],
      diningTableID: localStorage.getItem('diningTableID'),
      activeTab: 'waiting',
      selectedTable: 'all',
      selectedYear: 'all',
      selectedMonth: 'all',
      selectedDate: 'all',
      years: [],
      months: [],
      dates: [],
    };
  },
  created() {
    const today = new Date();
    this.selectedYear = today.getFullYear();
    this.selectedMonth = today.getMonth() + 1;
    this.selectedDate = today.getDate();
    this.getOrderItems();
    this.getTables();
    this.getYears();
    this.getMonths();
    this.getDates();
  },
  computed: {
    ...mapState(['user', 'cart', 'helper']),
    cartItems() {
      return this.cart.items;
    },
    filteredSessions() {
      let sessions = this.tablesessions;

      // 会計状況で絞り込み
      if (this.activeTab === 'waiting') {
        sessions = sessions.filter((session) => session.status === 1);
      } else if (this.activeTab === 'completed') {
        sessions = sessions.filter((session) => session.status === 2);
      }

      // 注文卓で絞り込み
      if (this.selectedTable !== 'all') {
        sessions = sessions.filter((session) => session.dining_table_id === this.selectedTable);
      }

      // 年で絞り込み
      if (this.selectedYear !== 'all') {
        sessions = sessions.filter((session) => new Date(session.ended_at).getFullYear() === Number(this.selectedYear));
      }

      // 月で絞り込み
      if (this.selectedMonth !== 'all') {
        sessions = sessions.filter((session) => new Date(session.ended_at).getMonth() + 1 === Number(this.selectedMonth));
      }

      // 日で絞り込み
      if (this.selectedDate !== 'all') {
        sessions = sessions.filter((session) => new Date(session.ended_at).getDate() === Number(this.selectedDate));
      }

      return sessions;
    },
  },
  methods: {
    async getOrderItems() {
      await this.getTableSessions(); // テーブルセッションを取得
      this.axios({
        method: 'GET',
        url: '/v1/orderitem/get/list',
        params: {
          // excludeMenu: 4, //その他を除外
          includeSession: [this.tablesessions[0]?.id],
          includeTable: this.diningTableID,
          user_id: this.user.id,
        },
      })
        .then((response) => {
          const res = response.data;
          this.orderitems = res.list.data;
          this.calculateTotalAmount(); // 合計金額を計算
        })
        .catch((error) => {
          if (error.response) console.log(error.response);
          else console.log(error);
        });
    },
    calculateTotalAmount() {
      this.totalAmount = this.orderitems.reduce(
        (sum, item) => sum + item.quantity * item.menuitems.price,
        0,
      );
    },
    getTables() {
      this.axios({
        method: 'GET',
        url: '/v1/diningtable/get/list',
        params: {
          user_id: this.user.id,
        },
      })
        .then((response) => {
          this.tables = response.data.list.data;
        })
        .catch((error) => {
          if (error.response) console.log(error.response);
          else console.log(error);
        });
    },
    updateTableSessions() {
      this.axios({
        method: 'POST',
        url: '/v1/tablesession/update',
        data: {
          id: 1,
          status: 1,
          user_id: this.user.id,
        },
      })
        .then((res) => {
          console.log(res.data);
          this.$store.dispatch('cart/reset', { root: true });
          this.$router.push('/checkout');
        })
        .catch((error) => {
          if (error.response) console.log(error.response);
          else console.log(error);
        });
    },
    getTableSessions() {
      return new Promise((resolve, reject) => { // Promiseを返すように変更
        this.axios({
          method: 'GET',
          url: '/v1/tablesession/get/list',
          params: {
            status: [1, 2], // 会計待ち中の卓のみ取得
            user_id: this.user.id,
          },
        })
          .then((response) => {
            const res = response.data;
            this.tablesessions = res.list.data;
            resolve(); // 非同期処理が成功したらresolveを呼び出す
          })
          .catch((error) => {
            if (error.response) console.log(error.response);
            else console.log(error);
            reject(error); // 非同期処理が失敗したらrejectを呼び出す
          });
      });
    },
    showOrderDetail(session) {
      const data = {
        session,
      };
      const args = {
        modalName: 'OrderDetail',
        data,
      };
      this.$store.dispatch('modal/contents/showModal', args, { root: true });
    },
    setActiveTab(tab) {
      this.activeTab = tab; // タブを切り替える
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      const month = date.getMonth() + 1; // 月は0から始まるため+1
      const day = date.getDate();
      const hours = date.getHours();
      const minutes = date.getMinutes().toString().padStart(2, '0'); // 分を2桁にする
      return `${month}/${day} ${hours}:${minutes}`;
    },
    getYears() {
      // 現在の年を取得
      const currentYear = new Date().getFullYear();
      // 過去5年分の年を取得
      this.years = Array.from({ length: 5 }, (_, i) => currentYear - i);
    },
    getMonths() {
      // 1から12までの月を取得
      this.months = Array.from({ length: 12 }, (_, i) => i + 1);
    },
    getDates() {
      // 1から31までの日を取得
      this.dates = Array.from({ length: 31 }, (_, i) => i + 1);
    },
    async fetchData() {
      await this.getTableSessions();
    },
  },
};
</script>

<style scoped>
.orderContainer {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding: 2vw;
  position: relative;
}

.orderTitle {
  font-family: 'HGS明朝B', serif;
  font-size: 50px;
  font-weight: bold;
  color: #333;
  text-align: center;
  margin-bottom: 10px;
}

.titleLine {
  width: 90%;
  border: 3px solid #333;
  margin-bottom: 20px;
}

.orderList {
  width: 90%;
  height: 65vh;
  overflow-y: auto;
  border: 3px solid #333;
}

.orderTable {
  width: 100%;
  height: 55vh;
  font-family: '游明朝', serif;
  font-size: 2vw;
  color: #333;
  background-color: transparent;
}

.orderTable th,
.orderTable td {
  width: 20%;
  height: 10vh;
  font-size: 2vw;
  font-weight: normal;
  padding: 10px;
  border: 3px solid #333;
  text-align: center;
  background-image: url('/img/menu/paperboard-texture.jpg');
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.orderTable th {
  font-size: 2vw;
  font-weight: bold;
  position: sticky;
  top: 0;
  vertical-align: top;
}

.orderTable tfoot {
  position: sticky;
  bottom: 0;
  z-index: 1;
  border: 3px solid #333;
}

.orderTable tfoot td {
  font-size: 2vw;
  font-weight: bold;
  padding: 10px;
  border: 3px solid #333;
  text-align: center;
}

.statusFilter {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.statusFilter select {
  font-size: 1.5vw;
  padding: 5%;
  border: 1px solid #333;
  border-radius: 4px;
  background-color: transparent;
  cursor: pointer;
}

.dateFilter {
  display: flex; 
  align-items: center;
  flex-direction: row;
  justify-content: center;
  gap: 8px;
}

.dateFilter select {
  font-size: 1vw;
  padding: 3%;
  border: 1px solid #333;
  border-radius: 4px;
  background-color: transparent;
  cursor: pointer;
  font-weight: bold;
}

.totalAmount {
  font-size: 1vw;
  font-weight: bold;
  line-height: 1.2;
}

.buttonContainer {
  position: absolute;
  bottom: 5%;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 20px;
}

.backButton {
  background-color: transparent;
  color: #333;
  font-family: '游明朝', serif;
  font-size: 1.5vw;
  padding: 10px 30px;
  border: 2px solid #333;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.reloadButton {
  background-color: #953127;
  color: #ffffff;
  font-family: '游明朝', serif;
  font-size: 1.5vw;
  padding: 10px 30px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.detailButton {
  background-color: #953127;
  color: #ffffff;
  font-family: '游明朝', serif;
  font-size: 2vw;
  padding: 8px 40px;
  border: 2px solid #333;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s;
}

</style>
